const futureOfCallerId = {
  slug: 'future-of-caller-id',
  title: 'The future of caller identification',
  description:
    'STIR/SHAKEN, branded calling, and stronger verification — what may reduce spoofing in Australia and globally.',
  category: 'guides',
  guideType: 'overview',
  readMinutes: 5,
  partnerTip: 'none',
  relatedSlugs: ['understanding-caller-id-australia', 'caller-id-spoofing'],
  sections: [
    {
      type: 'paragraph',
      text: 'Carriers and regulators are pushing authenticated calling so displayed numbers are harder to fake. Progress is uneven across countries and phone types.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'STIR/SHAKEN and similar standards',
    },
    {
      type: 'paragraph',
      text: 'Cryptographic signing of call origin helps networks label calls as verified, possible spam, or unknown. Not every call path supports it yet, especially some international and VoIP routes.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Branded and enriched caller ID',
    },
    {
      type: 'paragraph',
      text: 'Businesses may show logos and names when calls are authenticated. That can build trust for real companies — but users must still verify unexpected calls.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'What will not change soon',
    },
    {
      type: 'list',
      items: [
        'Social engineering — scammers will shift to scripts that bypass technology',
        'Need for community reports and consumer education',
        'Importance of hanging up and verifying independently',
      ],
    },
    {
      type: 'link',
      to: '/learn/caller-id-spoofing',
      label: 'Caller ID spoofing today',
    },
  ],
};

export default futureOfCallerId;
